import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";

const CONFIG: SpokePageConfig = {
  slug: "commercial-contractor-marketing-colorado",
  metaTitle: "Commercial Contractor Marketing in Colorado | Websites & SEO",
  metaDescription: "Marketing for Colorado commercial contractors: tenant finish, excavation, metal buildings. Websites from $1,850, local SEO from $950/month, month-to-month.",
  breadcrumbs: [{ label: "Home", to: "/" }],
  currentLabel: "Commercial Contractor Marketing",
  eyebrow: "Commercial Contractors — Colorado",
  h1: (
    <>
      Commercial Contractor <span className="text-brand-gold">Marketing</span> in Colorado
    </>
  ),
  heroDescription: "Win more bids for tenant finish, excavation, metal buildings and commercial build-outs.",
  intro: "Property managers, developers and facility buyers search Google and ask AI tools before they request a bid. We build the website, project pages and Google Maps presence that put your company on their short list across Colorado Springs, Denver, Castle Rock and the Front Range.",
  definition: { term: "Commercial contractor marketing", body: "Helping builders of offices, warehouses, retail and site work get found by the people who hire them: owners, developers and property managers." },
  whatWeDo: [
    { title: "Project portfolio", body: "Pages for each type of job, with photos and scope." },
    { title: "Service pages", body: "Tenant finish, excavation, metal buildings, concrete and more." },
    { title: "Google Maps", body: "A complete profile for every office or yard you run." },
    { title: "Bid-ready website", body: "Clear capabilities, safety record and a simple request form." },
    { title: "AI search", body: "Plain answers ChatGPT and Google can repeat." },
    { title: "Clear pricing", body: "Websites from $1,850. Marketing from $950/mo." },
  ],
  whyThisMarket: [
    { heading: "Big jobs, few searches", body: "Every commercial lead is worth a lot, so ranking for a handful of searches pays off." },
    { heading: "Buyers check you first", body: "Developers look at your website and past projects before they call." },
    { heading: "Front Range growth", body: "New warehouses and retail keep going up from Pueblo to Fort Collins." },
  ],
  relatedLinks: [
    { to: "/pricing", label: "Pricing" },
    { to: "/free-mockup", label: "Get a free website mockup" },
    { to: "/free-audit", label: "Get a free marketing audit" },
    { to: "/colorado-springs-headquarters", label: "Colorado Springs headquarters" },
    { to: "/web-design-castle-rock-colorado", label: "Castle Rock web design company" },
    { to: "/case-studies", label: "Colorado case studies" },
  ],
  faqs: [
    { q: "How much does it cost?", a: "Websites are $1,850 (Starter), $2,750 (Pro) or $5,950 (Expert), one-time, with one year of hosting and SSL. Monthly marketing is $950, $1,650 or $2,750 per month. Edits and repairs are $250/hour." },
    { q: "Do I have to sign a long contract?", a: "No. Monthly marketing is month-to-month." },
    { q: "Where are you located?", a: "Our office is at 3210 E Woodmen Rd STE 110, Colorado Springs, CO 80920. We serve businesses across Colorado." },
    { q: "How fast can my website be ready?", a: "Most websites are ready in under 7 business days." },
  ],
  serviceName: "Commercial Contractor Marketing in Colorado",
  serviceDescription: "Marketing for Colorado commercial contractors: tenant finish, excavation, metal buildings. Websites from $1,850, local SEO from $950/month, month-to-month.",
  areaServed: "Colorado",
};

export const Route = createFileRoute("/commercial-contractor-marketing-colorado")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
